import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
    BasicSelect
} from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
    name: 'UpdateNDR',
    components: {
        VueElementLoading,
        Treeselect,
        BasicSelect,
        PageTracker
    },
    mixins: [PageTracker],
    data: function () {
        return {
            ShippingID: '',
            ticketId: '',
            isLoading: false,
            shipmenttypeList: [{
                text: "Delivery"
            }],
            shipmenttypeObj: {
                text: ""
            },
            shipmenttype: '',
            processcode:'',
            NDRCode:'',
            OldStatusCode:'',
            NDRId:'',
            NDRList:[],
            NDRItemObj:{ value: "",text: ""},
            NDRListFlt:[],
            NDR:'',
            Status:'',
            userDataKey : ''
        }
    },
    created: function () {
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        this.loadNDRList();
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;

        //console.log('Mixin is working for :',result);
    },
    methods: {
        validateForm(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this.Update();
                }
            }).catch(() => {
                console.log('errors exist', this.errors)
            });
        },
        Update() {
            this.isLoading = true;
            let requestobj = {
                "ShippingID": this.ShippingID,
                "shipmenttype": this.shipmenttype,
                "LastModifiedBy": this.localusermailid,
                 "ticketId":this.ticketId,
                 "processcode":'P003',
                 "uniquecode":this.NDR,
                 "Status": this.OldStatusCode
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'websupport/update/ndr/manuallyfor/pending/ofd/shipment',
                data: requestobj
            })
                .then(async result => {
                    if (result.data.code == 200) {
                        let TrackerInfo = {
                            projectname:"Last Mile",
                            type: "Web",
                            userid: this.localuserid,
                            username: this.localusermailid,
                            meta: {
                                "event": "updateNdrInRunsheet",
                                "ShippingID": this.ShippingID.toString(),
                                "shipmenttype": this.shipmenttype,
                                "ticketId":this.ticketId,
                                "uniquecode":this.NDR
                            }
                        }
                        this.PageTracker(TrackerInfo);
                        this.$alertify.success('Successfully Updated!!');
                    } else {
                        this.$alertify.error(result.data.message);
                    }
                    this.isLoading = false;
                    this.reset();
                })
        },
        selectshipmenttype(obj) {
            this.shipmenttypeObj = obj,
            this.shipmenttype = obj.text;
        },

        loadNDRList() {
            this.NDRArrayList = []
            this.NDRList = []
            this.NDRListFlt = []

              axios({
                method: 'POST',
                url: apiUrl.api_url + 'websupport/get/userprocessmapping/by/processcode',
                data: {
                    "processcode":"P003"
                }
              })
              .then(result => {
                if (result.data.code == 200) {
                  this.NDRArrayList = result.data.data.ReasonStatuses;
                //   console.log("NDRArrayList",this.NDRArrayList)
                  for (var i = 0; i < this.NDRArrayList.length; i++) {
                    this.NDRList.push({
                      value: this.NDRArrayList[i].userprocessmappingid,
                      text: `${this.NDRArrayList[i].uniquecode}-${this.NDRArrayList[i].userprocess}`,
                      OldStatusCode:this.NDRArrayList[i].OldStatusCode,
                      uniquecode : this.NDRArrayList[i].uniquecode
                    })
                    this.NDRListFlt.push({
                      value: this.NDRArrayList[i].userprocessmappingid,
                      text: `${this.NDRArrayList[i].uniquecode} -${this.NDRArrayList[i].userprocess}  `,
                      OldStatusCode:this.NDRArrayList[i].OldStatusCode,
                      uniquecode : this.NDRArrayList[i].uniquecode
                    })
                  }
                } else {
                  this.$alertify.error(result.data.data.message?result.data.data.message:'No Record found')
                }
              }, error => {
                console.error(error)
              })
          },
          selectNDR(obj){
            this.NDRItemObj = obj
            this.NDRId = obj.value
            this.NDR = obj.uniquecode
            this.OldStatusCode = obj.OldStatusCode
          },
        reset() {
            this.$validator.reset();
            this.ShippingID = '';
            this.isLoading = false;
            this.shipmenttypeObj = {};
            this.shipmenttype = '';
            this.ticketId = '';
            this.NDRItemObj = {};
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/UpdateNDR/UpdateNDR.component.js